'use strict';

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var styles = require('@material-ui/styles');
var SnackbarContext = require('./SnackbarContext.js');
var SnackbarMessage = require('./SnackbarMessage.js');
var v4 = require('../node_modules/uuid/dist/esm-browser/v4.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var useStyles = styles.makeStyles(theme => ({
  container: {
    position: 'fixed',
    left: 16,
    bottom: 16,
    display: 'flex',
    flexDirection: 'column-reverse',
    transitions: theme.transitions.create('height'),
    zIndex: theme.zIndex.snackbar
  }
}));

var SnackbarProvider = _ref => {
  var {
    maxMessages = 3,
    children
  } = _ref;
  var classes = useStyles();
  var [messages, setMessages] = React__default['default'].useState([]);
  var [reaper, setReaper] = React__default['default'].useState(new Set());

  function addMessage(_ref2) {
    var {
      type,
      text
    } = _ref2;
    var newMessages = messages.concat({
      type,
      text,
      id: v4()
    });
    setMessages(newMessages);
  }

  function clearMessages() {
    var newReaper = new Set(reaper);
    messages.forEach(message => newReaper.add(message.id));
    setReaper(newReaper);
  }

  function killMessage(idToKill) {
    var newReaper = new Set([...reaper, idToKill]);
    setReaper(newReaper);
  } // Clean up dead messages.


  React__default['default'].useEffect(() => {
    if (reaper.size) {
      var filteredMessages = messages.filter(message => !reaper.has(message.id));
      setMessages(filteredMessages);
      setReaper(new Set());
    }
  }, [reaper, messages]);
  return /*#__PURE__*/React__default['default'].createElement(SnackbarContext.SnackbarContext.Provider, {
    value: {
      addMessage,
      clearMessages,
      error: text => addMessage({
        type: 'error',
        text
      }),
      warning: text => addMessage({
        type: 'warning',
        text
      }),
      success: text => addMessage({
        type: 'success',
        text
      }),
      info: text => addMessage({
        type: 'info',
        text
      })
    }
  }, children, messages.length > 0 && /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.container
  }, messages.slice(0, maxMessages).map((message, index) => /*#__PURE__*/React__default['default'].createElement(SnackbarMessage.SnackbarMessage, _rollupPluginBabelHelpers['extends']({}, message, {
    key: message.id,
    kill: () => killMessage(message.id),
    shouldMakeRoom: index === 0 && messages.length > maxMessages
  })))));
};

SnackbarProvider.propTypes = {
  /** Wrapped content of the provider. */
  children: index.node,

  /** The maximum number of messages that can appear on the screen. */
  maxMessages: index.number
};

module.exports = SnackbarProvider;
